import { buildLocalizedPath } from '~/utils/buildLocalizedPath';
import {
  ALL_LOCALE_CODES,
  getFallbackLocale,
  isLocaleCode,
  isLocaleExcluded,
  type LocaleCode,
} from '~/utils/excludedLocales';
import { resolveProtocolTarget } from '~/utils/resolveProtocolTarget';


/**
 * Resolves protocol-handler query `target` to a localized app path (e.g. `/en/`).
 */
export function getProtocolRedirectDestination(
  target: unknown,
  fallbackLocale: string,
  excludedLocales: readonly LocaleCode[] = [],
  preferredLocale?: unknown,
): string {
  let path = '/';
  let targetLocale = isLocaleExcluded(fallbackLocale, excludedLocales)
    ? getFallbackLocale(excludedLocales, preferredLocale)
    : fallbackLocale;

  if (typeof target === 'string' && target.length > 0) {
    const resolved = resolveProtocolTarget(target, [...ALL_LOCALE_CODES]);

    path = resolved.path;

    if (resolved.locale) {
      targetLocale = isLocaleExcluded(resolved.locale, excludedLocales)
        ? getFallbackLocale(excludedLocales, preferredLocale)
        : resolved.locale;
    }
  }

  return buildLocalizedPath(path, targetLocale);
}

export function localeFromRoutePath(routePath: string): string {
  const code = routePath.split('/')[1] || '';

  return isLocaleCode(code) ? code : 'en';
}
